import { createSlice } from "@reduxjs/toolkit";

export const organizationBillingSlice = createSlice({
  name: "organizationBillingSlice",
  initialState: {
    orgCode: null,

    isGettingOrgBilling: false,
    getOrgBillingMessage: null,
    getOrgBillingError: null,
    orgBilling: null,

    isUpdatingOrgBilling: false,
    updateOrgBillingMessage: null,
    updateOrgBillingError: null,

    isCreatingOrgBilling: false,
    createOrgBillingMessage: null,
    createOrgBillingError: null,

    isDeletingOrgBilling: false,
    deleteOrgBillingMessage: null,
    deleteOrgBillingError: null,
  },
  reducers: {
    getOrgBilling: (state, action) => {
      state.isGettingOrgBilling = true;
      state.getOrgBillingMessage = null;
      state.getOrgBillingError = null;
      state.orgCode = action.payload;
    },
    getOrgBillingSuccessful: (state, action) => {
      state.isGettingOrgBilling = false;
      state.getOrgBillingMessage = "Billing Info retrieved successfully";
      state.orgBilling = action.payload;
    },
    getOrgBillingFailure: (state, action) => {
      state.isGettingOrgBilling = false;
      state.getOrgBillingMessage = null;
      state.getOrgBillingError = action.payload;
      state.orgBilling = null;
    },
    updateOrgBilling: (state, action) => {
      state.isUpdatingOrgBilling = true;
      state.updateOrgBillingMessage = null;
      state.updateOrgBillingError = null;
    },
    updateOrgBillingSuccessful: (state, action) => {
      state.isUpdatingOrgBilling = false;
      state.updateOrgBillingMessage = action.payload;
      state.updateOrgBillingError = null;
    },
    updateOrgBillingFailure: (state, action) => {
      state.isUpdatingOrgBilling = false;
      state.updateOrgBillingMessage = null;
      state.updateOrgBillingError = action.payload;
    },
    createOrgBilling: (state, action) => {
      state.isCreatingOrgBilling = true;
      state.createOrgBillingMessage = null;
      state.createOrgBillingError = null;
    },
    createOrgBillingSuccessful: (state, action) => {
      state.isCreatingOrgBilling = false;
      state.createOrgBillingMessage = action.payload;
      state.createOrgBillingError = null;
    },
    createOrgBillingFailure: (state, action) => {
      console.log("🚀 ~ action:", action)
      state.isCreatingOrgBilling = false;
      state.createOrgBillingMessage = null;
      state.createOrgBillingError = action.payload;
    },
    deleteOrgBilling: (state, action) => {
      state.isDeletingOrgBilling = true;
      state.deleteOrgBillingMessage = null;
      state.deleteOrgBillingError = null;
    },
    deleteOrgBillingSuccessful: (state, action) => {
      state.isDeletingOrgBilling = false;
      state.deleteOrgBillingMessage = action.payload;
      state.deleteOrgBillingError = null;
    },
    deleteOrgBillingFailure: (state, action) => {
      state.isDeletingOrgBilling = false;
      state.deleteOrgBillingMessage = null;
      state.deleteOrgBillingError = action.payload;
    },
    clearAllOrgBillingMessages : (state) => {},
    clearAllOrgBillingMessagesSuccessful : (state) => {
      state.getOrgBillingError = null;
      state.getOrgBillingMessage = null;
      state.updateOrgBillingMessage = null;
      state.updateOrgBillingError = null;
      state.deleteOrgBillingMessage = null;
      state.deleteOrgBillingError = null;  
      state.createOrgBillingMessage= null;
      state.createOrgBillingError= null;
    }
  }
});

export const {
  getOrgBilling,
  getOrgBillingSuccessful,
  getOrgBillingFailure,
  updateOrgBilling,
  updateOrgBillingSuccessful,
  updateOrgBillingFailure,
  createOrgBilling,
  createOrgBillingSuccessful,
  createOrgBillingFailure,
  deleteOrgBilling,
  deleteOrgBillingSuccessful,
  deleteOrgBillingFailure,
  clearAllOrgBillingMessages,
  clearAllOrgBillingMessagesSuccessful
} = organizationBillingSlice.actions;

export default organizationBillingSlice.reducer;